import script from "./build-sprint-update-review.vue?vue&type=script&setup=true&lang=ts"
export * from "./build-sprint-update-review.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__